import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    alertMessage: { type: String, required: true },
    alertState: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  alertMessage: string;
  alertState: string;
}

const alertState = ref("neutral");


const Props = toRefs(props);

watch(Props.alertState, (value) => {
  alertState.value = value;
});

/** ×ボタン押下時にアラートを非表示にする */
const ChangeAlertState = () => {
  alertState.value = "neutral";
};

const __returned__ = { alertState, props, Props, ChangeAlertState }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})